import script from "./RelatorioDre.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioDre.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioDre.vue?vue&type=style&index=0&id=275168fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275168fe"]])

export default __exports__